import { components } from '@doltech/pageManagement/dto';
import { fromScreen } from '@doltech/core/lib/responsive/responsive.util';
import dynamic from 'next/dynamic';
import * as React from 'react';
import styled from 'styled-components';

import { DescriptionEditorViewProps } from '../DescriptionEditor/View/DescriptionEditorView.types';
import { colorsV2 } from '../../../figma/colors-v2';

const DescriptionEditorView = dynamic(
  () =>
    import('../DescriptionEditor/View/DescriptionEditorView').then(
      (mod) => mod.DescriptionEditorView
    ),
  { ssr: false }
);

const Main = styled.div`
  h2,
  p {
    font-family: Inter, sans-serif;
    color: ${colorsV2.black100};
  }
  h2 {
    font-size: 20px;
    line-height: 28px;
    font-weight: 600;
  }
  p {
    font-size: 14px;
    line-height: 20px;
  }
  ${fromScreen(768)} {
    h2 {
      font-size: 24px;
      line-height: 32px;
    }
    p {
      font-size: 16px;
      line-height: 24px;
    }
  }
`;

const CONTAINER_MAX_HEIGHT = 500;

export interface ExtraInfoViewProps
  extends Pick<DescriptionEditorViewProps, 'compact' | 'fontInter'> {
  extraInfo: components['schemas']['ExtraInfoDTO'];
}

export const ExtraInfoView = (props: ExtraInfoViewProps) => {
  const { extraInfo, ...rest } = props;

  if (!extraInfo?.body) return null;

  return (
    <Main>
      <DescriptionEditorView
        body={extraInfo?.body}
        mediaInfos={extraInfo?.mediaInfos}
        compactConfig={{
          mode: 'limit-container',
          maxHeight: CONTAINER_MAX_HEIGHT,
        }}
        {...rest}
      />
    </Main>
  );
};
